export default "__VITE_ASSET__DRpPJTFl__"